<template>
    <a-modal
            :width="'50%'"
            v-model="updateLocate"
            :title="$t('org.locationInfo')"
            :maskClosable="maskClosable"
            destroyOnClose
            @ok="handleOk">

        <div style="padding:20px;">
            <a-card>
                <a-form :form="locateForm">
                    <a-form-item :label="level == 2 ? $t('org.integratorAddress') : $t('org.orgAddress')" v-bind="formItemLayout">
                        <a-input style="max-width:300px" size="small" disabled v-model="address" v-decorator="['address',{ rules: [{ required: true, message: level == 2 ? $t('org.integratorAddress') : $t('org.orgAddress')}] }]"></a-input>
                        <a-button size="small" style="margin-left:10px" type="primary" @click="setLocate" :disabled="mkrTool && mkrTool._isOpen">{{$t('global.set')}}</a-button>
                        <SearchAddress :map="bmap" width="80%" top="40px" />
                    </a-form-item>
                    
                </a-form>
                
                <BMap @getMap="getMap" :height="450" ></BMap>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import BMap from '../../components/common/BMap'
    import SearchAddress from '../../components/BMapComponents/SearchAddress'
    import { baiduKey } from '../../config/baiduKey';
    export default {
        name: 'ZUpdateOrgLocate',
        components: {
            BMap,
            SearchAddress
        },
        data() {
            return {
                updateLocate: false,
                maskClosable: false,
                chartSettings: [],
                chartSeries: [],
                locateForm: null,
                address: null,
                mkrTool: null,
                city: null,
                bmap: null,
                orgId: null,
                level: null,
                locateMarker: null,
                cityListControl: null,
                lat: null,
                lng: null,
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    }
                }
            }
        },
        methods: {
            getMap (map) {
                this.bmap = map
            },
            getScrollTop: function () {
                let scrollTop = 0;
                if (document.documentElement && document.documentElement.scrollTop) {
                    scrollTop = document.documentElement.scrollTop;
                } else if (document.body) {
                    scrollTop = document.body.scrollTop;
                }
                return scrollTop;
            },
            setScrollTop: function (top) {
                if (!isNaN(top)) {
                    if (document.documentElement && document.documentElement.scrollTop !== undefined) {
                        document.documentElement.scrollTop = top;
                    } else if (document.body) {
                        document.body.scrollTop = top;
                    }
                }
            },
            handleOk() {
                this.locateForm.validateFieldsAndScroll((err) => {
                    if(!err){
                        let param = {}
                        param.id = this.orgId
                        param.lat = this.lat
                        param.lng = this.lng
                        param.coordType = 'BD09'
                        param.mapLevel = this.bmap.getZoom()
                        param.region = this.city
                        param.address = this.address

                        this.$http.put(config.api.org_address_url,param).then((response) => {
                            if(response.code == 0){
                                this.updateLocate = false
                                // this.$message.success('修改成功')
                                this.$notification.success({
                                  message: this.$t('global.commitSuccess')
                                })
                                this.$emit("updateSuccess",this.orgId)
                            }else {
                                this.$message.error(response.desc)
                            }
                        })
                    }
                })
            },
            setLocate(){
                this.mkrTool.open()
            },
            afterSet: function (echarts) {
                this.bmap = echarts.getModel().getComponent('bmap').getBMap()
            },
            showModel(org){
                this.locateForm = this.$form.createForm(this)
                this.updateLocate = true
                this.orgId = org.id
                this.level = org.level
                let _this = this
                this.top = this.getScrollTop()
                if (this.top) {
                    this.setScrollTop(0)
                }


                this.address = org.address
                setTimeout(() => {
                    _this.locateForm.setFieldsValue({
                        address: org.address
                    });

                    // if(!_this.cityListControl){
                    //     var size = new window.BMap.Size(10, 20);
                    //     _this.cityListControl = new window.BMap.CityListControl({
                    //         anchor: window.BMAP_ANCHOR_TOP_LEFT,
                    //         offset: size,
                    //     })
                    //     _this.bmap.addControl(_this.cityListControl);
                    // }
                },200);

                setTimeout(() => {
                    if(_this.locateMarker){
                        _this.bmap.removeOverlay(_this.locateMarker)
                    }
                    let point  = new window.BMap.Point(org.lng,org.lat)
                    _this.locateMarker = new window.BMap.Marker(point)
                    _this.bmap.addOverlay(_this.locateMarker)
                    _this.bmap.centerAndZoom(point,org.mapLevel)

                    _this.mkrTool = new window.BMapLib.MarkerTool( _this.bmap, {autoClose: true, followText: ""})
                    _this.mkrTool.addEventListener("markend", function(e) {
                        _this.bmap.removeOverlay(e.marker)
                        if(_this.locateMarker){
                            _this.bmap.removeOverlay(_this.locateMarker)
                        }
                        _this.locateMarker = new window.BMap.Marker({"lat":e.marker.point.lat,"lng":e.marker.point.lng});
                        _this.bmap.addOverlay(_this.locateMarker)

                        var geoc = new window.BMap.Geocoder()
                        var pt = new window.BMap.Point(e.marker.point.lng,e.marker.point.lat)
                        geoc.getLocation(pt, function (rs) {
                            console.log(rs)
                            if (rs.address !== '') {
                                _this.address  = rs.address;
                            }else {
                                if ((rs.addressComponents.city !== '') && (rs.addressComponents.country !== '')) {
                                    _this.address  = rs.addressComponents.city + ', ' + rs.addressComponents.country;
                                }
                            }
                            if(rs.addressComponents.district !== ''){
                                _this.city = rs.addressComponents.district
                            } else if (rs.addressComponents.city !== ''){
                                _this.city = rs.addressComponents.city
                            } else if (rs.addressComponents.province !== ''){
                                _this.city = rs.addressComponents.province
                            }
                            _this.lat = e.marker.point.lat
                            _this.lng = e.marker.point.lng
                            _this.locateForm.setFieldsValue({
                                address:  _this.address
                            });
                        })
                    })

                },500)
            }
        },
        created () {
            this.chartSettings = {
                key: baiduKey,
                bmap: {
                    center: [116.417854, 39.921988],
                    zoom: 18,
                    roam: true,
                    mapStyle: {}
                }
            }
            this.chartSeries = []
        }
    }
</script>